var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import DatePicker from 'react-datepicker';
import { _formatStringToDate } from '../../../../utils/objectToFormData';
import { ApplicationContext } from '../../../../ApplicationContext';
/**
 *
 */
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    /**
     *
     * @param props
     */
    function DateInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onResize = _this.onResize.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onDateChange = _this.onDateChange.bind(_this);
        return _this;
    }
    /**
     *
     */
    DateInput.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onResize);
    };
    /**
     *
     */
    DateInput.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
    };
    /**
     *
     * @return {*}
     */
    DateInput.prototype.render = function () {
        var date = this.props.value; //this.props.value ? this.props.value : new Date();
        var _a = this.props, inline = _a.inline, required = _a.required, className = _a.className, disabled = _a.disabled, minDate = _a.minDate, placeholderText = _a.placeholderText, autoComplete = _a.autoComplete, intl = _a.intl, name = _a.name, id = _a.id, showTimeSelect = _a.showTimeSelect, dateFormat = _a.dateFormat;
        var openToDate = this.props.openToDate;
        return (React.createElement(DatePicker, { name: name, id: id, className: className, disabled: disabled, disabledKeyboardNavigation: true, selected: this._processDatePickerValue(date), locale: 'nl', dateFormat: dateFormat ? dateFormat : 'dd-MM-yyyy', timeFormat: "HH:mm", dropdownMode: "scroll", minDate: minDate, placeholderText: placeholderText, autoComplete: autoComplete, required: required, onFocus: this.onFocus, onBlur: this.onBlur, onChange: this.onDateChange, onChangeRaw: this.onChange, openToDate: openToDate, timeIntervals: 30, showTimeSelect: showTimeSelect, inline: inline, popperPlacement: 'bottom', 
            // @ts-ignore
            calendarStartDay: 1, timeCaption: intl.formatMessage({ id: 'label.generic.time' }), previousMonthButtonLabel: intl.formatMessage({ id: 'datepicker.month.previous' }), nextMonthButtonLabel: intl.formatMessage({ id: 'datepicker.month.next' }) }));
    };
    /**
     *
     */
    DateInput.prototype.onResize = function () {
        this.forceUpdate();
    };
    /**
     *
     * @param e
     */
    DateInput.prototype.onChange = function (e) {
        if (this.props.disableManualInput) {
            e.preventDefault();
            return;
        }
        if (this.props.onChange) {
            var reverse = true;
            // check if year is leading, if so don't reverse date string in _formatStringToDate
            try {
                reverse = e.target.value.split('-')[0].length !== 4;
            }
            catch (exception) { }
            try {
                var date = _formatStringToDate(e.target.value, reverse);
                this.props.onChange(e, date);
            }
            catch (exception) {
            }
        }
    };
    /**
     *
     * @param date
     * @param e
     */
    DateInput.prototype.onDateChange = function (date, e) {
        if (date && this.props.onChange) {
            this.props.onChange(e, date);
        }
        else {
            console.log('ongeldige datum', date);
        }
    };
    /**
     *
     * @param e
     */
    DateInput.prototype.onFocus = function (e) {
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    };
    /**
     *
     * @param e
     */
    DateInput.prototype.onBlur = function (e) {
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    };
    /**
     *
     * @param date
     * @return {*}
     * @private
     */
    DateInput.prototype._processDatePickerValue = function (date) {
        if (date instanceof Date && isNaN(date.getTime())) {
            return null;
        }
        return date; // ? moment(date) : null;
    };
    DateInput.defaultProps = {
        placeholderText: 'DD-MM-YYYY',
        openToDate: null,
        autoComplete: 'off'
    };
    return DateInput;
}(React.Component));
export default DateInput;
DateInput.contextType = ApplicationContext;
